import { render, staticRenderFns } from "./PurchaseInvoice.vue?vue&type=template&id=9a8e3c36&scoped=true"
import script from "./PurchaseInvoice.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoice.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoice.vue?vue&type=style&index=0&id=9a8e3c36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8e3c36",
  null
  
)

export default component.exports